import React, { Component } from "react";
import AntdAutoComplete, {
  AutoCompleteProps,
} from "antd/lib/auto-complete";
import "antd/lib/auto-complete/style";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";

interface FACProps extends AutoCompleteProps {
  forwardedRef?: any;
}
const { Option, OptGroup } = AntdAutoComplete;
class FdxAutoComplete extends Component<FACProps> {
  render() {
    const { forwardedRef, ...rest } = this.props;
    return <AntdAutoComplete {...rest} ref={forwardedRef} />;
  }
}

const AutoComplete: any = React.forwardRef((props: FACProps, ref) => {
  return (
    <ConfigConsumer>
      {({ pagePoint }: ConfigConsumerEProps) =>
        pagePoint ? (
          <PagePoint
            compType="AutoComplete"
            {...props}
            render={eventprops => (
              <FdxAutoComplete {...props} forwardedRef={ref} {...eventprops} data-ui-role='AutoComplete'/>
            )}
          ></PagePoint>
        ) : (
          <FdxAutoComplete {...props} forwardedRef={ref} />
        )
      }
    </ConfigConsumer>
  );
});

AutoComplete.Option = Option;
AutoComplete.OptGroup = OptGroup;
export default AutoComplete;



// WEBPACK FOOTER //
// ./src/components/auto-complete/index.tsx